<template>

    <div class="table-responsive">

        <div class="input-content no-border">
            <input v-model="search_existing_modules" placeholder="Search by Name" type="text"

            @keyup="keyUpSearchExistingModules" />
        </div>

        <table class="table table-bordered">
            <tr class="align-midle">
                <th v-for="(header, index) in table_headers" :key="index">
                      <a v-if="header == 'Created on' " class="pointer" @click="ascending = !ascending">{{header}}<img class="sort-icon" src="../../../assets/images/icons/solid/vector_arrow.svg"></a> 
                        <a v-else>{{header}}</a> 
                </th>
            </tr>
            <tr v-if="!table_body_data.length">
                <td colspan="9" class="text-center">Loading, please wait...</td>
            </tr>
            <tr  v-for="module in table_body_data" :value="module">
                <!--<td  class="thumb-container pb-100" :style="{ 'background-image' : 'url('+module.image+')' }"></td>-->
                <td class="text-center align-middle">{{ module.id }}</td>
                <td>
                    <span v-if="table_view == 'module'">
                        <router-link tag="a" :to="{name: 'sme.'+table_view+'.view', params:{id: module.id}}">
                        <p class="mt-2 mb-2"><strong>{{ module.title }}</strong></p>
                        </router-link>
                    </span>
                    <span v-else>
                          <p class="mt-2 mb-2"><strong>{{ module.title }}</strong></p>
                    </span>
                   
                    <p class="mb-2" v-if="module.description != null"><small>{{ module.description.EN}}</small></p>
                </td>
                <td v-if="table_view == 'module'">
                    <div v-if="!module.has_quiz" class="m-0 progress-icon disapproved"></div>
                    <div v-else class="m-0 progress-icon approved"></div>
                </td>
                <td v-if="table_view == 'module' || table_view == 'lesson'">
                    {{module.notes}}
                </td>
                <td >
                    <!-- modal with lessons -->
                    <div class="trigger-hidden-content ml-1 d-inline-block">
                        <span class=" button">

                            <strong v-if="table_view== 'module'">{{ module.lessons.length}}</strong>
                            <strong v-if="table_view== 'lesson'">{{ module.modules.length}}</strong>
                            
                        </span>
                        <div class="hidden-content hc-right hidden-content-table">
                            <div>
                                <div v-if="table_view== 'module'" class="h4">Lessons</div>
                                <div v-if="table_view== 'lesson'" class="h4">Modules</div>

                                <table class="table table-bordered">
                                    <thead>
                                        <th>ID</th>
                                        <th>Name</th>
                                    </thead>
                                    <tbody  v-if="table_view== 'module'">
                                        <tr v-for="lesson in module.lessons">
                                            <td>{{ lesson.id }}</td>
                                            <td>
                                                <div><strong>{{ lesson.title }}</strong></div>
                                                <div>{{ lesson.notes }}</div>
                                            </td>
                                        </tr>
                                    </tbody>
                                    <tbody  v-if="table_view== 'lesson'">
                                        <tr v-for="module in module.modules">
                                            <td><button  @click="openInNewTab(module.id, 'module')">{{ module.id }}</button></td>
                                            <td>
                                                <div><strong>{{ module.title }}</strong></div>
                                                <div>{{ module.notes }}</div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>	
                            </div>
                        </div>
                    </div>
                </td>
                <td  v-if="table_view== 'module'">
                    <!-- modal with courses -->
                    <div class="trigger-hidden-content ml-1 d-inline-block">
                        <span class=" button">

                            <strong>{{ module.courses.length}}</strong>
                            
                        </span>
                        <div class="hidden-content hc-right hidden-content-table">
                            <div>
                                <div class="h4">Programs</div>
                                <table class="table table-bordered">
                                    <thead>
                                        <th>ID</th>
                                        <th>Name</th>
                                    </thead>
                                    <tbody>
                                        <tr v-for="course in module.courses">
                                            <td><button  @click="openInNewTab(course.id, 'edit')">{{ course.id }}</button></td>
                                            <td>
                                                <div><strong>{{ course.name }}</strong></div>
                                                <div>{{ course.description }}</div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>	
                            </div>
                        </div>
                    </div>
                </td>
                <td  v-if="table_view== 'module'">
                    <!-- modal with agencies -->
                    <div class="trigger-hidden-content ml-1 d-inline-block">
                        <span class=" button">

                            <strong>{{ module.organizations.length || Object.keys(module.organizations).length}}</strong>
                            
                        </span>
                        <div class="hidden-content hc-right hidden-content-table">
                            <div>
                                <div class="h4">Agencies</div>
                                <table class="table table-bordered">
                                    <thead>
                                        <th>ID</th>
                                        <th>Name</th>
                                    </thead>
                                    <tbody>
                                        <tr v-for="organization in module.organizations">
                                            <td>{{ organization.id }}</td>
                                            <td>
                                                <div><strong>{{ organization.name }}</strong></div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>	
                            </div>
                        </div>
                    </div>
                </td>
                <td  >{{ module.created_at }}</td>
                <td v-if="table_view== 'module'">
                                <div class="trigger-hidden-content ml-1 d-inline-block">
                                    <span class=" button">
                                        <img width="15" src="../../../assets/images/icons/solid/ellipsis-h_white.svg">
                                    </span>
                                    <div class="hidden-content hc-right-bottom">
                                        <div>
                                            <ul class="list-unstyled text-left">
                                                <li :class="{'input-disabled': module.is_clone}" class="pb-2 pt-2 d-flex align-items-center cursor-pointer" @click="showModalDuplicate(module)">
                                                    <img width="12" class="mr-2" src="../../../assets/images/icons/solid/clone.svg">
                                                    <span> Duplicate</span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </td>
                <td v-if="show_add_module" valign="middle" class="justify-content-center align-middle">
                    <div class="button m-auto circle-button green-button" @click="addExistingModule(module)"
                            v-if="!module.in_course">
                        <img width="15" src="../../../assets/images/icons/solid/plus_white.svg">
                    </div>
                    <div class="button m-auto circle-button green2-content" v-else>
                        <img width="15" src="../../../assets/images/icons/solid/check_white.svg">
                    </div>
                </td>
            </tr>
        </table>

        <b-pagination align="right" :total-rows="pagination_existing_modules.total" v-model="pagination_existing_modules.current_page" 
                :per-page="pagination_existing_modules.per_page" @change="setPageExistingModules">
        </b-pagination>

    </div>
</template>
<script>
import { EventBus } from './../../../event_bus.js';
export default {
    props:['table_headers','table_body_data','show_add_module','pagination_existing_modules','table_view'],
    data: function(){
        return{
            search_existing_modules:'',
            ascending:false

        }
    },
    mounted: function(){
        EventBus.$on('reset_seach_key_module', () => {
					this.search_existing_modules = ''
                    //this.$emit('setPageExistingModules',1)
			});
    },
    watch:{
        ascending: function(val){
            this.table_body_data.sort(function(a, b){
                    var aa = a.created_at.split('/').reverse().join(""),
                    bb = b.created_at.split('/').reverse().join("");
                    if(val){
                        return aa > bb ? -1 : (aa < bb ? 1 : 0);
                    }else{
                        return aa < bb ? -1 : (aa > bb ? 1 : 0);
                    }
                   
            })
        }
    },
    methods:{
        addExistingModule: function(module){
            this.$emit('addExistingModule',module)
        },
        keyUpSearchExistingModules: function(){
               this.$emit('keyUpSearchExistingModules',this.search_existing_modules)
        },
        setPageExistingModules: function(page){
            this.$emit('setPageExistingModules',{page:page, search:this.search_existing_modules})
        },
        showModalDuplicate: function(course){
            var module_view_duplicate = true
            this.$emit('showModalDuplicate', course, module_view_duplicate)
        },
        openInNewTab(objectID, objectType) {
            window.open(
                "/s/" + objectID + "/" + objectType
            );
        },
    }

}
</script>



// WEBPACK FOOTER //
// src/components/sme/SharedViews/SMETableViewCourse.vue